<div id="modal-decision">
    <div class="modal-header border-0">
        <button type="button" class="btn-close" aria-label="Close" data-dismiss="modal-decision" (click)="cerrar()"></button>
    </div>
    <div class="modal-body text-start pt-0">
        <h4>{{mensaje}}</h4>
        <input type="text" class="form-control" [(ngModel)]="inputValor" id="inputText" *ngIf="!esNumero && !esOpciones">
        <input type="number" class="form-control" [(ngModel)]="inputValorNumero" id="inputNumber" *ngIf="esNumero">
        <ng-select *ngIf="esOpciones && configuracionOpciones != null" [items]="configuracionOpciones.items"
            [bindLabel]="configuracionOpciones.label || ''" [(ngModel)]="item"
            [clearable]="configuracionOpciones.clear" [multiple]="configuracionOpciones.multiple"></ng-select>
    </div>

    <div class="modal-footer border-0">
        <button id="neoBtnCancel" type="button" class="btn btn-secondary" (click)="cerrar()">CANCELAR</button>
        <button id="neoBtnAccept" type="button" class="btn btn-primary" (click)="enviar()">ACEPTAR</button>
    </div>
</div>
